// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__14wxb","author":"Table_author__2LwGW","authorImage":"Table_authorImage__3DZf0","unreadRow":"Table_unreadRow__e7kBm"};